import { StatusCodes } from 'http-status-codes';

export enum AcceptedResponseCodes {
    Ok = StatusCodes.OK,
    PartialContent = StatusCodes.PARTIAL_CONTENT,
}
